// extracted by mini-css-extract-plugin
export default {"content":"Privacy_content__a4QHB","page":"Privacy_page__0ZHpn","languageButton":"Privacy_languageButton__D1x3B"};